module.exports = __webpack_public_path__ + "img/BAU_Partners_Infographics_9.94e5cf3d.png";